'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactSlidedown = require('react-slidedown');

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _AmazonStaffLanding = require('./AmazonStaffLanding.css');

var _AmazonStaffLanding2 = _interopRequireDefault(_AmazonStaffLanding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonStaffLanding = (_dec = (0, _reactCssModules2.default)(_AmazonStaffLanding2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonStaffLanding, _Component);

  function AmazonStaffLanding(props) {
    (0, _classCallCheck3.default)(this, AmazonStaffLanding);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonStaffLanding.__proto__ || (0, _getPrototypeOf2.default)(AmazonStaffLanding)).call(this, props));

    _this.state = {
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    };
    return _this;
  }

  (0, _createClass3.default)(AmazonStaffLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var headlineImg = require('../../../static/images/monkeys-circle.jpg');
      var mobileBannerStyle = this.state.mobileBannerFixed ? 'mobile-fixed' : 'mobile-relative';

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'hl-wrap' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', {
                src: headlineImg,
                alt: 'Save for your future without ruining theirs',
                styleName: 'hl-img-sm visible-xs'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'hl' },
                'Your retirement plan is destroying the Amazon rainforest... but it doesn\u2019t have to.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Amazon offers employees a 401(k) plan that invests over $500 million dollars in fossil fuels, deforestation, and arms manufacturers, among other risky industries. These unsustainable industries threaten the environment ',
                  _react2.default.createElement(
                    'i',
                    null,
                    'and'
                  ),
                  ' your retirement. Most Amazon employees don\u2019t know their 401(k)s are destroying the Amazon rainforest, but that\u2019s about to change.'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Join ',
                      _react2.default.createElement(
                        'i',
                        null,
                        'As You Sow'
                      ),
                      ' to urge Amazon management to live up to their public commitments by offering conscientious employees like you a more sustainable default retirement fund.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'hidden-xs' },
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'subtitle' },
                    'Amazon 401(k) by the numbers'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        '52%'
                      ),
                      ' of plan assets are invested in the default Vanguard Target Retirement Funds series.'
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      'Plan participants have ',
                      _react2.default.createElement(
                        'b',
                        null,
                        '+$500M'
                      ),
                      ' flagged by environmental and social risk screens.'
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      'Only ',
                      _react2.default.createElement(
                        'b',
                        null,
                        '1 / 26'
                      ),
                      ' plan options report a sustainability mandate.'
                    )
                  ),
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'subtitle' },
                    'Our letter to company management'
                  ),
                  _react2.default.createElement(_components.AmazonCompanyLetter, { differentPage: true })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links hidden-xs' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-lbl' },
                    'More'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.plans + '/amazon-com',
                        title: 'Amazon 401(k) scorecard',
                        xstrong: true
                      },
                      'See the scorecard for the Amazon 401(k)',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.eduCenter,
                        title: 'Action center',
                        xstrong: true
                      },
                      'Action center',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hl-img-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'petition-widget-wrap' },
                _react2.default.createElement('img', {
                  src: headlineImg,
                  alt: 'Save for your future without ruining theirs',
                  styleName: 'hl-img hidden-xs'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sticky-widget ' + mobileBannerStyle },
                  _react2.default.createElement('div', { id: 'section1' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sticky-widget-close visible-xs' },
                    _react2.default.createElement(
                      'div',
                      {
                        onClick: function onClick() {
                          //
                          _this2.setState({
                            mobileBannerFixed: false
                          });
                        }
                      },
                      _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-close' })
                    )
                  ),
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'thumbs-up-top-label' },
                    'Give us a thumbs up if you want a more sustainable 401(k).'
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.amazonStaffThanks,
                      title: 'Count me in',
                      log: _analytics2.default.eventStaffSupport('Amazon', 'count_me_in'),
                      linkedin: '4674186',
                      fbPixel: true,
                      id: 'amazon-staff-support'
                    },
                    _react2.default.createElement(
                      'button',
                      { styleName: 'thumbs-up-flex wiggle' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'thumbs-up-label' },
                        'Count me in'
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'thumbs-up' },
                        _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-thumbs-o-up' })
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'show-more-button',
                title: 'Learn more',
                onClick: function onClick(e) {
                  _this2.setState({ showFullPetition: !_this2.state.showFullPetition });
                }
              },
              'Learn more',
              _react2.default.createElement(_components.LinkIcon, { faclass: this.state.showFullPetition ? 'fa-angle-double-up' : 'fa-angle-double-down' })
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              this.state.showFullPetition ? _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'h2',
                  { styleName: 'subtitle' },
                  'Amazon 401(k) by the numbers'
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      '52%'
                    ),
                    ' of plan assets are invested in the default Vanguard Target Retirement Funds series.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Plan participants have ',
                    _react2.default.createElement(
                      'b',
                      null,
                      '+$500M'
                    ),
                    ' flagged by environmental and social risk screens.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Only ',
                    _react2.default.createElement(
                      'b',
                      null,
                      '1 / 26'
                    ),
                    ' plan options report a sustainability mandate.'
                  )
                ),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'subtitle' },
                  'Our letter to company management'
                ),
                _react2.default.createElement(_components.AmazonCompanyLetter, { differentPage: true })
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links visible-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-lbl' },
              'More'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.plans + '/amazon-com',
                  title: 'Amazon 401(k) scorecard',
                  xstrong: true
                },
                'See the scorecard for the Amazon 401(k)',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.eduCenter,
                  title: 'Action center',
                  xstrong: true
                },
                'Action center',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    }
  }]);
  return AmazonStaffLanding;
}(_react.Component)) || _class);
exports.default = AmazonStaffLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AmazonStaffLanding/AmazonStaffLanding.js
// module id = 1457
// module chunks = 0